import { useId } from "react";

/**
 * mhwork 品牌 Logo(跟桌面端 mhwork-claw 同款,矢量 SVG)。
 *
 * - 圆角方形容器,135° 品牌渐变(蓝青 → 紫 → 粉)
 * - 白色粗 M + 中段向上尖峰
 * - 右上角 ✦ 四角星
 */
export function Logo({
  size = 40,
  radius,
  className,
  style,
}: {
  size?: number;
  /** 圆角半径(相对 size,默认 14%) */
  radius?: number;
  className?: string;
  style?: React.CSSProperties;
}) {
  const rawId = useId();
  const gradId = `mh-logo-bg-${rawId.replace(/[^a-zA-Z0-9_-]/g, "")}`;
  const rx = radius ?? Math.round(size * 0.14);
  const viewRx = Math.round((rx / size) * 256);

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 256 256"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ flexShrink: 0, ...style }}
      role="img"
      aria-label="mhwork"
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6EA6E8" />
          <stop offset="50%" stopColor="#8B7BE8" />
          <stop offset="100%" stopColor="#E895C2" />
        </linearGradient>
      </defs>
      <rect x="0" y="0" width="256" height="256" rx={viewRx} fill={`url(#${gradId})`} />
      <path
        d="M 56 204 L 56 62 L 128 124 L 200 62 L 200 204"
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="30"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
      <path d="M 128 46 L 112 104 L 144 104 Z" fill="#FFFFFF" />
      <path
        d="M 210 42 L 213.5 51 L 222 54 L 213.5 57 L 210 66 L 206.5 57 L 198 54 L 206.5 51 Z"
        fill="#FFFFFF"
        fillOpacity="0.92"
      />
    </svg>
  );
}
